import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { loginState } from '../interfaces/loginState.interface';

export const selectorSesionUsuarioFeature: any = (state: AppState) =>
  state.login;

export const selectorLoading: any = createSelector(
  selectorSesionUsuarioFeature,
  (state: loginState) => state.loading
);

export const selectorSesionUsuario: any = createSelector(
  selectorSesionUsuarioFeature,
  (state: loginState) => state.sesionUsuario
);
